(function($) {
    var wishlistIcon = 'https://cdn.shopify.com/s/files/1/0654/3874/4660/files/imgi_10_width_200.png?v=1773046618';
    var removeWishlistIcon = 'https://cdn.shopify.com/s/files/1/0654/3874/4660/files/remove-wishlist.png?v=1773045891';
    var ADDON_RULE_HIDE_ALL = '__hide_all__';
    var variantPrefixSpacingBound = false;
    var variantPrefixSpacingObserver = null;
    var ringSizeGuideOptionsCache = {};
    var ringSizeGuideEscapeBound = false;
    var ringSizeGuideScrollLockCount = 0;
    var isProductPage = document.body && document.body.classList.contains('product');
    
    $(document).ready(function() {
        hideEmptyAccordion();
        initLineItemSubmit();
        initRingSizeGuideOptions();
        bindLineItemSelectLabelOpen();
        wireDependencies();
        wireAddonDependencies();
        wireDynamicLetterFields();
        wireLineItemTextValidation();
        initVariantPrefixSpacing();
        bindVariantPrefixSpacingEvents();

        if (isProductPage) {
            logWhenWishlistButtonAppears();

            $(document)
                .off('click.customWishlist', '.wishlist-btn')
                .on('click.customWishlist', '.wishlist-btn', function(e) {
                    e.preventDefault();

                    var $wishlistTrigger = $('.frcp-wishlist-btn').first();
                    if (!$wishlistTrigger.length) return;

                    var iconUrl = $wishlistTrigger.hasClass('frcp-wishlist-btn--remove') ? wishlistIcon : removeWishlistIcon;
                    $wishlistTrigger.trigger('click');

                    $(this).attr('src', iconUrl);
                });
        }
    })

    function getCartItemsSectionId() {
        var $el = $('cart-items-component[data-section-id]').first();
        return $el.length ? $el.attr('data-section-id') : null;
    }

    function getDisplayCartItemCount(cart) {
        if (!cart || !Array.isArray(cart.items)) {
            return parseInt((cart && cart.item_count) || 0, 10) || 0;
        }

        return cart.items.reduce(function(total, item) {
            var properties = (item && item.properties) || {};
            var bundleRole = $.trim((properties._bundle_role || properties['Bundle Role'] || '') + '').toLowerCase();
            if (bundleRole === 'addon') return total;

            var quantity = parseInt(item && item.quantity, 10);
            return total + (quantity > 0 ? quantity : 0);
        }, 0);
    }

    function updateHeaderCartBubble(count) {
        count = parseInt(count || 0, 10) || 0;

        var $root = $('cart-drawer-component > button').first();
        if (!$root.length) return;

        var $bubble = $root.find('.cart-bubble');
        var $countEl = $root.find('.cart-bubble__text-count');
        var $srEl = $root.find('.cart-bubble__text .visually-hidden');
        var $icon = $root.find('cart-icon');

        if ($countEl.length) $countEl.text(count);
        if ($srEl.length) $srEl.text('Total items in cart: ' + count);

        $root.attr('aria-label', 'Open cart Total items in cart: ' + count);

        if ($bubble.length) {
            $bubble.toggleClass('visually-hidden', count === 0);
        }

        if ($countEl.length) {
            $countEl.toggleClass('hidden', count === 0);
        }

        if ($icon.length) {
            $icon.toggleClass('header-actions__cart-icon--has-cart', count > 0);
        }
    }

    function refreshCartUI() {
        var headerSectionId = getCartItemsSectionId();
        if (!headerSectionId) return $.Deferred().resolve().promise();

        var p1 = $.getJSON('/?sections=' + encodeURIComponent(headerSectionId))
            .then(function (sections) {
                var html = sections && sections[headerSectionId];
                if (!html) return;

                var $doc = $($.parseHTML(html, document, true));
                var $newDialog = $doc.find('dialog.cart-drawer__dialog').first();
                if (!$newDialog.length) return;

                var $currentDialog = $('dialog.cart-drawer__dialog').first();
                if (!$currentDialog.length) return;

                $currentDialog.attr('class', $newDialog.attr('class'));
                $currentDialog.html($newDialog.html());
            });

        var p2 = $.getJSON('/cart.js')
            .then(function (cart) {
                updateHeaderCartBubble(getDisplayCartItemCount(cart));
            });

        return;
    }

    function getInlineAddToCartErrorElement($form) {
        var $host = $form.closest('product-form-component');
        if (!$host.length) $host = $form;

        var $error = $host.find('[data-custom-atc-error]').first();
        if ($error.length) return $error;

        $error = $('<div>', {
            class: 'custom-atc-inline-error hidden',
            'data-custom-atc-error': '',
            role: 'alert',
            'aria-live': 'polite'
        });

        $form.after($error);
        return $error;
    }

    function clearInlineAddToCartError($form) {
        var $error = getInlineAddToCartErrorElement($form);
        var timerId = $form.data('customAtcErrorTimerId');

        if (timerId) {
            clearTimeout(timerId);
            $form.removeData('customAtcErrorTimerId');
        }

        $error.addClass('hidden').text('');
    }

    function showInlineAddToCartError($form, message) {
        var $error = getInlineAddToCartErrorElement($form);

        clearInlineAddToCartError($form);

        $error.text(message).removeClass('hidden');

        var timerId = setTimeout(function () {
            $error.addClass('hidden').text('');
            $form.removeData('customAtcErrorTimerId');
        }, 6000);

        $form.data('customAtcErrorTimerId', timerId);
    }

    function initLineItemSubmit() {
        $(document)
        .off('click.addonAtc', 'product-form-component form.shopify-product-form button[type="submit"]')
        .on('click.addonAtc', 'product-form-component form.shopify-product-form button[type="submit"]', function (e) {
            var $form = $(this).closest('form.shopify-product-form');
            if (!$form.length) return;
            clearInlineAddToCartError($form);

            var ok = injectLineItemProperties($form);
            if (!ok) {
                e.preventDefault();
                e.stopImmediatePropagation();
                showInlineAddToCartError($form, 'Please select/fill all required options before adding to cart.');
                return false;
            }

            var productId = $form.closest('product-form-component').attr('data-product-id');
            var selectedAddon = getSelectedAddon(productId);

            if (!selectedAddon) return;

            e.preventDefault();
            e.stopImmediatePropagation();

            var mainVariant = $.trim($form.find('input[name="id"]').val());
            var addonVariant = $.trim(selectedAddon.variantId);
            var quantity = parseInt($form.find('input[name="quantity"]').val(), 10);
            if (!quantity || quantity < 1) quantity = 1;
            var bundleId = 'bundle_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);

            var properties = {};
            $form.find('input[data-injected-line-item="true"]').each(function () {
                var k = $(this).attr('name').replace('properties[', '').replace(']', '');
                properties[k] = $(this).val();
            });

            properties._bundle_id = bundleId;
            properties._bundle_role = 'parent';
            properties['Bundle ID'] = bundleId;
            properties['Add-on'] = selectedAddon.label;

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [
                    { id: mainVariant, quantity: quantity, properties: properties },
                    {
                        id: addonVariant,
                        quantity: quantity,
                        properties: {
                            _bundle_id: bundleId,
                            _bundle_role: 'addon',
                            'Bundle ID': bundleId
                        }
                    }
                    ]
                })
            })
            .then(function (res) {
                return res.json().then(function (data) {
                    if (!res.ok || (data && data.status)) {
                        var message = (data && (data.description || data.message)) || 'Sorry—something went wrong adding to cart.';
                        throw new Error(message);
                    }
                    return data;
                });
            })
            .then(function () {
                clearInlineAddToCartError($form);
                return refreshCartUI();
            })
            .catch(function (error) {
                showInlineAddToCartError($form, (error && error.message) || 'Sorry—something went wrong adding to cart.');
            });

            return false;
        });

        $(document)
        .off('input.addonAtcError change.addonAtcError', 'product-form-component form.shopify-product-form input, product-form-component form.shopify-product-form select, product-form-component form.shopify-product-form textarea')
        .on('input.addonAtcError change.addonAtcError', 'product-form-component form.shopify-product-form input, product-form-component form.shopify-product-form select, product-form-component form.shopify-product-form textarea', function () {
            var $form = $(this).closest('form.shopify-product-form');
            if (!$form.length) return;
            clearInlineAddToCartError($form);
        });
    }

    function initRingSizeGuideOptions() {
        $('[data-line-item-input][data-load-ring-sizes="true"]').each(function () {
            var $select = $(this);
            if ($select.attr('data-depends-on')) return;
            if (!isRingProductInput($select)) return;
            if ($select.attr('data-ring-size-guide-initialized') === 'true') return;

            $select.attr('data-ring-size-guide-initialized', 'true');

            var sizeGuideUrl = $.trim($select.attr('data-size-guide-url') || '/pages/size-guide');
            var columnIndex = parseInt($select.attr('data-size-guide-column-index') || '1', 10);
            if (isNaN(columnIndex) || columnIndex < 0) columnIndex = 1;

            fetchRingSizeOptions(sizeGuideUrl, columnIndex)
                .then(function (guideData) {
                    if (!guideData || !guideData.options || !guideData.options.length) return;

                    $select.data('ringSizeGuideData', guideData);
                    rebuildSelect($select, guideData.options);
                    renderRingSizeGuideDrawer($select, guideData);
                    updateRingSizeConversion($select);
                    bindRingSizeGuideEvents($select);

                    $select
                        .off('change.ringSizeConversion')
                        .on('change.ringSizeConversion', function () {
                            updateRingSizeConversion($(this));
                        });

                    $select.trigger('change');
                })
                .catch(function (error) {
                    $select.removeAttr('data-ring-size-guide-initialized');
                    console.warn('Unable to load ring sizes from size guide', error);
                });
        });
    }

    function bindLineItemSelectLabelOpen() {
        $(document)
            .off('click.lineItemSelectLabelOpen', '.line-item-select-prefix')
            .on('click.lineItemSelectLabelOpen', '.line-item-select-prefix', function (event) {
                var targetId = $.trim($(this).attr('for') || '');
                if (!targetId) return;

                var select = document.getElementById(targetId);
                if (!select) return;

                event.preventDefault();
                select.focus({ preventScroll: true });

                if (typeof select.showPicker === 'function') {
                    try {
                        select.showPicker();
                        return;
                    } catch (error) {
                    }
                }

                var mouseDownEvent = new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window });
                select.dispatchEvent(mouseDownEvent);
                select.click();
            });
    }

    function isRingProductInput($input) {
        var type = ($input.attr('data-product-type') || '').toLowerCase();
        var title = ($input.attr('data-product-title') || '').toLowerCase();
        var tags = ($input.attr('data-product-tags') || '').toLowerCase();
        var haystack = (type + ' ' + title + ' ' + tags).trim();
        return haystack.indexOf('ring') !== -1;
    }

    function fetchRingSizeOptions(url, columnIndex) {
        var cacheKey = url + '::' + String(columnIndex);
        if (ringSizeGuideOptionsCache[cacheKey]) {
            return Promise.resolve(ringSizeGuideOptionsCache[cacheKey]);
        }

        return fetch(url, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(function (response) {
                if (!response.ok) throw new Error('Size guide request failed: ' + response.status);
                return response.text();
            })
            .then(function (html) {
                var guideData = parseRingSizesFromHtml(html, columnIndex);
                ringSizeGuideOptionsCache[cacheKey] = guideData;
                return guideData;
            });
    }

    function parseRingSizesFromHtml(html, columnIndex) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var table =
            doc.querySelector('.size-guide-table table') ||
            doc.querySelector('.size-guide-content-section .content-wrapper table') ||
            doc.querySelector('table');
        if (!table) return { options: [], rows: [], selectedColumnIndex: columnIndex };

        var rows = table.querySelectorAll('tr');
        var options = [];
        var parsedRows = [];
        var seen = {};

        rows.forEach(function (row, rowIndex) {
            if (rowIndex === 0) return;
            var cells = row.querySelectorAll('td');
            if (!cells.length || columnIndex >= cells.length) return;

            var values = [];
            cells.forEach(function (cell) {
                var cleanValue = (cell.textContent || '')
                    .replace(/\*/g, '')
                    .replace(/\s+/g, ' ')
                    .trim();
                values.push(cleanValue);
            });

            var value = values[columnIndex];

            if (!value || seen[value]) return;

            seen[value] = true;
            options.push(value);
            parsedRows.push(values);
        });

        return {
            options: options,
            rows: parsedRows,
            selectedColumnIndex: columnIndex
        };
    }

    function updateRingSizeConversion($select) {
        var $conversion = $select.closest('[data-line-item-field]').find('[data-ring-size-conversion]').first();
        if (!$conversion.length) return;

        var guideData = $select.data('ringSizeGuideData');
        if (!guideData || !guideData.rows || !guideData.rows.length) {
            $conversion.prop('hidden', true);
            return;
        }

        var selectedValue = $.trim($select.val() || '');
        if (!selectedValue) {
            $conversion.prop('hidden', true);
            return;
        }

        var selectedColumnIndex = parseInt(guideData.selectedColumnIndex, 10);
        if (isNaN(selectedColumnIndex) || selectedColumnIndex < 0) selectedColumnIndex = 1;

        var matchingRow = null;
        for (var i = 0; i < guideData.rows.length; i++) {
            var row = guideData.rows[i];
            if (!row || selectedColumnIndex >= row.length) continue;
            if ($.trim(row[selectedColumnIndex] || '') === selectedValue) {
                matchingRow = row;
                break;
            }
        }

        if (!matchingRow) {
            $conversion.prop('hidden', true);
            return;
        }

        var usValue = $.trim((matchingRow[1] || '').toString());
        var euValue = $.trim((matchingRow[2] || '').toString());
        if (!usValue && !euValue) {
            $conversion.prop('hidden', true);
            return;
        }

        $conversion.find('[data-ring-size-us]').text(usValue ? 'US: ' + usValue : '');
        $conversion.find('[data-ring-size-eu]').text(euValue ? 'EU: ' + euValue : '');
        $conversion.prop('hidden', false);
        highlightRingSizeGuideRow($select, matchingRow);
    }

    function renderRingSizeGuideDrawer($select, guideData) {
        var $field = $select.closest('[data-line-item-field]');
        var $drawer = getRingSizeGuideDrawer($field);
        var $body = $drawer.find('[data-ring-size-guide-table-body]').first();
        if (!$body.length) {
            $body = $field.find('[data-ring-size-guide-table-body]').first();
        }
        if (!$body.length || !guideData || !guideData.rows) return;

        $body.empty();

        guideData.rows.forEach(function (row) {
            var auUkValue = $.trim((row[0] || '').toString());
            var usValue = $.trim((row[1] || '').toString());
            var circumferenceValue = $.trim((row[3] || '').toString());
            var diameterValue = $.trim((row[4] || '').toString());
            var combinedValue = [diameterValue, circumferenceValue].filter(Boolean).join(' / ');
            var compareValue = $.trim((row[guideData.selectedColumnIndex] || '').toString());

            var $tr = $('<tr>').attr('data-guide-value', compareValue);
            $('<td>').text(auUkValue).appendTo($tr);
            $('<td>').text(combinedValue).appendTo($tr);
            $('<td>')
                .attr('data-ring-size-guide-region-value', '')
                .attr('data-size-us', usValue)
                .attr('data-size-eu', $.trim((row[2] || '').toString()))
                .text(usValue)
                .appendTo($tr);
            $body.append($tr);
        });

        updateRingSizeGuideRegion($field, $drawer);
    }

    function highlightRingSizeGuideRow($select, row) {
        var $field = $select.closest('[data-line-item-field]');
        var $drawer = getRingSizeGuideDrawer($field);
        var $body = $drawer.find('[data-ring-size-guide-table-body]').first();
        if (!$body.length) {
            $body = $field.find('[data-ring-size-guide-table-body]').first();
        }
        if (!$body.length || !row) return;

        var guideData = $select.data('ringSizeGuideData');
        if (!guideData) return;

        var compareValue = $.trim((row[guideData.selectedColumnIndex] || '').toString());
        $body.find('tr').removeClass('is-active');
        $body.find('tr[data-guide-value="' + cssEscape(compareValue) + '"]').addClass('is-active');
    }

    function bindRingSizeGuideEvents($select) {
        var $field = $select.closest('[data-line-item-field]');
        var $drawer = ensureRingSizeGuideDrawerMounted($field);
        if (!$drawer.length) return;

        $field
            .off('click.ringSizeGuideOpen', '[data-ring-size-guide-open]')
            .on('click.ringSizeGuideOpen', '[data-ring-size-guide-open]', function () {
                if ($drawer.hasClass('is-open')) return;
                lockPageScrollForRingSizeGuide();
                $drawer.removeAttr('hidden');
                $drawer.prop('hidden', false);
                requestAnimationFrame(function () {
                    $drawer.addClass('is-open');
                });
            });

        $drawer
            .off('click.ringSizeGuideClose', '[data-ring-size-guide-close]')
            .on('click.ringSizeGuideClose', '[data-ring-size-guide-close]', function () {
                closeRingSizeGuideDrawer($drawer);
            });

        $drawer
            .off('change.ringSizeGuideRegion', '[data-ring-size-guide-region]')
            .on('change.ringSizeGuideRegion', '[data-ring-size-guide-region]', function () {
                updateRingSizeGuideRegion($field, $drawer);
            });

        if (!ringSizeGuideEscapeBound) {
            $(document).on('keydown.ringSizeGuide', function (event) {
                if (event.key !== 'Escape') return;
                $('[data-ring-size-guide-drawer].is-open').each(function () {
                    closeRingSizeGuideDrawer($(this));
                });
            });
            ringSizeGuideEscapeBound = true;
        }
    }

    function updateRingSizeGuideRegion($field, $drawer) {
        var $target = $drawer && $drawer.length ? $drawer : getRingSizeGuideDrawer($field);
        if (!$target.length) return;

        var region = ($target.find('[data-ring-size-guide-region]').first().val() || 'us').toLowerCase();
        var key = region === 'eu' ? 'sizeEu' : 'sizeUs';

        $target.find('[data-ring-size-guide-region-value]').each(function () {
            var $cell = $(this);
            var value = $.trim(($cell.data(key) || '').toString());
            $cell.text(value);
        });
    }

    function getRingSizeGuideOwner($field) {
        if (!$field || !$field.length) return '';
        return $.trim($field.attr('data-ring-size-guide-owner') || '');
    }

    function getRingSizeGuideDrawer($field) {
        if (!$field || !$field.length) return $();

        var owner = getRingSizeGuideOwner($field);
        if (owner) {
            var $ownedDrawer = $('[data-ring-size-guide-drawer][data-ring-size-guide-owner="' + cssEscape(owner) + '"]').first();
            if ($ownedDrawer.length) return $ownedDrawer;
        }

        return $field.find('[data-ring-size-guide-drawer]').first();
    }

    function ensureRingSizeGuideDrawerMounted($field) {
        var $drawer = getRingSizeGuideDrawer($field);
        if (!$drawer.length) return $drawer;

        if ($drawer.parent()[0] === document.body) return $drawer;

        var owner = getRingSizeGuideOwner($field);
        if (!owner) {
            owner = 'ring-size-guide-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
            $field.attr('data-ring-size-guide-owner', owner);
        }

        $drawer.attr('data-ring-size-guide-owner', owner);
        $drawer.appendTo(document.body);
        return $drawer;
    }

    function closeRingSizeGuideDrawer($drawer) {
        if (!$drawer || !$drawer.length) return;
        if (!$drawer.hasClass('is-open')) return;
        $drawer.removeClass('is-open');
        unlockPageScrollForRingSizeGuide();
        setTimeout(function () {
            if (!$drawer.hasClass('is-open')) {
                $drawer.attr('hidden', 'hidden');
                $drawer.prop('hidden', true);
            }
        }, 260);
    }

    function lockPageScrollForRingSizeGuide() {
        ringSizeGuideScrollLockCount += 1;

        var html = document.documentElement;
        if (!html) return;

        if (!html.hasAttribute('scroll-lock')) {
            html.setAttribute('scroll-lock', '');
            html.setAttribute('data-ring-size-guide-scroll-lock', 'true');
        }
    }

    function unlockPageScrollForRingSizeGuide() {
        ringSizeGuideScrollLockCount = Math.max(0, ringSizeGuideScrollLockCount - 1);
        if (ringSizeGuideScrollLockCount > 0) return;

        var html = document.documentElement;
        if (!html) return;

        if (html.getAttribute('data-ring-size-guide-scroll-lock') === 'true') {
            html.removeAttribute('scroll-lock');
            html.removeAttribute('data-ring-size-guide-scroll-lock');
        }
    }

    function cssEscape(value) {
        if (window.CSS && typeof window.CSS.escape === 'function') {
            return window.CSS.escape(value);
        }

        return String(value).replace(/("|\\)/g, '\\$1');
    }

    function injectLineItemProperties($form) {
        var $pfc = $form.closest('product-form-component');
        var productId = $pfc.attr('data-product-id');
        if (!productId) return true;

        $form.find('input[data-injected-line-item="true"]').remove();

        var $inputs = $('[data-line-item-input][data-product-id="' + productId + '"]');
        if (!$inputs.length) return true;

        var isValid = true;

        $inputs.each(function () {
            var $input = $(this);
            var propName = $input.attr('data-property-name');
            var value = $input.val();

            if ($input.attr('data-line-item-type') === 'text') {
                if (!validateLineItemInput($input)) {
                    isValid = false;
                    $input.focus();
                    return false;
                }
            }

            if ($input.prop('required') && (!value || value === '')) {
                isValid = false;
                $input.closest('details').prop('open', true);
                $input.focus();
                return false;
            }

            if (propName && value) {
                $('<input>', {
                    type: 'hidden',
                    name: 'properties[' + propName + ']',
                    value: value
                })
                .attr('data-injected-line-item', 'true')
                .appendTo($form);
            }
        });

        return isValid;
    }

    function getSelectedAddon(productId) {
        var $addon = $('[data-addon-select][data-product-id="' + productId + '"]');
        if (!$addon.length) return null;

        var variantId = $addon.val();
        if (!variantId) return null;
        var selectedText = $.trim($addon.find('option:selected').text() || '');
        selectedText = selectedText.replace(/\s*\([^)]*\)\s*$/, '');

        return {
            variantId: variantId,
            label: selectedText
        };
    }

    function hideEmptyAccordion() {
            $('.details').each(function() {
            const $details = $(this);
            const text = $details.find('.details-content').text().trim();
            if (!text) {
                $details.hide();
            } else {
                $details.show();
            }
        });
    }

    function logWhenWishlistButtonAppears() {
        var logged = false;
        var timeoutId = null;

        function addWishlistIconOnce() {
            if ($('.wishlist-btn').length) return;
            var $target = $('.custom-product h1').first();
            if (!$target.length) return;

            var iconUrl = $('.frcp-wishlist-btn').hasClass('frcp-wishlist-btn--remove') ? removeWishlistIcon : wishlistIcon ;

            var html = '<img class="wishlist-btn" src="' + iconUrl + '">';
            $target.append(html);
        }

        function check() {
            if (logged) return;
            if ($('.frcp-wishlist-btn').length) {
            logged = true;
            if (timeoutId) clearTimeout(timeoutId);
                addWishlistIconOnce();
            }
        }

        check();

        var observer = new MutationObserver(function () {
            check();
            addWishlistIconOnce();

            if (logged) observer.disconnect();
        });

        observer.observe(document.documentElement, { childList: true, subtree: true });

        timeoutId = setTimeout(function () {
            observer.disconnect();
        }, 6000);
    }

    function rebuildSelect($select, options) {
        var current = $select.val();

        $select.empty();

        (options || []).forEach(function (opt) {
            $select.append($('<option>', { value: opt, text: opt.replace("<br />", "") }));
        });

        if (current && options && options.indexOf(current) !== -1) {
            $select.val(current);
            return;
        }

        var firstValue = options && options.length ? options[0] : '';
        if (firstValue) {
            $select.val(firstValue);
        }
    }

    function wireDependencies() {
        $('[data-line-item-input][data-depends-on]').each(function () {
            var $child = $(this);
            var productId = $child.attr('data-product-id');
            var parentProp = $child.attr('data-depends-on');
            var rules = parseRules($child.attr('data-dependency-rules') || '');

            var $parent = $('[data-line-item-input][data-product-id="' + productId + '"][data-property-name="' + parentProp + '"]').first();
            if (!$parent.length) return;

            function apply() {
                var parentVal = $parent.val();
                rebuildSelect($child, rules[parentVal] || []);
            }

            $parent.off('change.dep').on('change.dep', apply);
            apply();
        });
    }

    function parseRules(raw) {
        var map = {};
        if (!raw) return map;

        raw.split(/[\n\r]+/).forEach(function(line) {
            line = $.trim(line);
            if (!line) return;

            var parts = line.split('=');
            if (parts.length < 2) return;

            var key = $.trim(parts[0]);
            var handles = $.trim(parts.slice(1).join('='))
            .split('|')
            .map(function(s){ return $.trim(s); })
            .filter(Boolean);

            if (key) map[key] = handles;
        });

        return map;
        }

    function parseAddonConfig(raw) {
        var config = {
            dependsOn: '',
            dependsOnList: [],
            rules: {}
        };

        if (!raw) return config;

        raw = raw.replace(/<br\s*\/?>/gi, '\n');

        raw.split(/[\n\r]+/).forEach(function(line) {
            line = $.trim(line);
            if (!line) return;

            if (line.toLowerCase().indexOf('depends_on:') === 0) {
                var dependsRaw = $.trim(line.substring('depends_on:'.length));
                config.dependsOnList = dependsRaw
                    .split(/[|,]/)
                    .map(function (s) { return $.trim(s); })
                    .filter(Boolean);
                config.dependsOn = config.dependsOnList[0] || '';
                return;
            }

            var parts = line.split('=');
            if (parts.length < 2) return;

            var key = $.trim(parts[0]);
            var handles = $.trim(parts.slice(1).join('='))
                .split('|')
                .map(function(s) { return $.trim(s); })
                .filter(Boolean);

            if(key) config.rules[key] = handles;
        });

        return config;
    }

    function getAllConditionalHandles(rules) {
        var all = [];

        $.each(rules, function(key, handles) {
            $.each(handles, function(_, handle) {
            handle = $.trim((handle || '').toLowerCase());
            if (!handle || handle.charAt(0) === '_') return;
            if ($.inArray(handle, all) === -1) all.push(handle);
            });
        });

        return all;
    }

    function normalizeRuleValue(value) {
        return $.trim((value || '').toLowerCase()).replace(/\s+/g, ' ');
    }

    function splitRuleKey(key) {
        return $.trim(key || '')
            .split('|')
            .map(function (part) { return $.trim(part); });
    }

    function addonHandleMatchesRule(handle, ruleHandle) {
        handle = $.trim((handle || '').toLowerCase());
        ruleHandle = $.trim((ruleHandle || '').toLowerCase());
        if (!handle || !ruleHandle) return false;
        return handle === ruleHandle || handle.indexOf(ruleHandle + '-') === 0;
    }

    function resolveAllowedAddonHandles(rules, dependsOnList, valuesByDependency) {
        if (!dependsOnList || !dependsOnList.length) return [];

        var bestHandles = [];
        var bestSpecificity = -1;

        $.each(rules, function (ruleKey, handles) {
            var parts = splitRuleKey(ruleKey);
            if (parts.length !== dependsOnList.length) return;

            var matched = true;
            var specificity = 0;

            for (var i = 0; i < dependsOnList.length; i++) {
                var expected = normalizeRuleValue(parts[i]);
                var actual = normalizeRuleValue(valuesByDependency[dependsOnList[i]]);

                if (expected === '*') continue;
                if (expected !== actual) {
                    matched = false;
                    break;
                }

                specificity++;
            }

            if (!matched) return;
            if (specificity < bestSpecificity) return;

            bestSpecificity = specificity;
            bestHandles = handles || [];
        });

        return bestHandles;
    }

    function findAddonDependencyInput(productId, dependsOn) {
        var $lineItemField = $('[data-line-item-input][data-product-id="' + productId + '"][data-property-name="' + dependsOn + '"]').first();
        if ($lineItemField.length) return $lineItemField;

        var optionName = 'options[' + dependsOn + ']';
        var $variantPicker = $('variant-picker[data-product-id="' + productId + '"]').first();
        if (!$variantPicker.length) return $();

        var $select = $variantPicker.find('select.variant-option__select[name="' + optionName + '"]').first();
        if ($select.length) return $select;

        var $checkedRadio = $variantPicker.find('input[name="' + optionName + '"]:checked').first();
        if ($checkedRadio.length) return $checkedRadio;

        return $();
    }

    function getVariantPickerParentValue(productId) {
        var $variantPicker = $('variant-picker[data-product-id="' + productId + '"]').first();
        if (!$variantPicker.length) return '';

        var $firstSelect = $variantPicker.find('select.variant-option__select').first();
        if ($firstSelect.length) return $.trim($firstSelect.val() || '');

        var $firstChecked = $variantPicker.find('fieldset.variant-option input:checked').first();
        if ($firstChecked.length) return $.trim($firstChecked.val() || '');

        return '';
    }

    function normalizeAddonGroup(value) {
        value = $.trim((value || '').toLowerCase());
        if (!value) return '';
        if (value.indexOf('necklace') !== -1) return 'necklace';
        if (value.indexOf('bracelet') !== -1) return 'bracelet';
        return '';
    }

    function filterOptionsByVariantSelection(allOptions, parentVal) {
        var group = normalizeAddonGroup(parentVal);
        if (!group) return allOptions;

        return $.grep(allOptions, function (opt) {
            if (!opt.handle) return true;

            var haystack = ((opt.handle || '') + ' ' + (opt.text || '')).toLowerCase();
            return haystack.indexOf(group) !== -1;
        });
    }

    function filterAddonOptions(productId) {
        var $addonSelect = $('[data-addon-select][data-product-id="' + productId + '"]').first();
        if (!$addonSelect.length) return;
        var previousValue = $.trim($addonSelect.val() || '');
        var $addonContainer = $addonSelect.closest('.add-ons');

        var config = parseAddonConfig($addonSelect.attr('data-addon-rules') || '');
        var dependsOnList = (config.dependsOnList && config.dependsOnList.length)
            ? config.dependsOnList
            : (config.dependsOn ? [config.dependsOn] : []);
        var valuesByDependency = {};
        var firstDependencyValue = '';

        $.each(dependsOnList, function (_, dependencyName) {
            var $dependencyInput = findAddonDependencyInput(productId, dependencyName);
            var dependencyValue = getDependencyValue($dependencyInput);
            valuesByDependency[dependencyName] = dependencyValue;
            if (!firstDependencyValue) firstDependencyValue = dependencyValue;
        });

        // Cache original options once
        if (!$addonSelect.data('all-options')) {
            var allOptions = [];
            $addonSelect.find('option').each(function () {
                allOptions.push({
                    value: $(this).attr('value') || '',
                    text: $(this).text(),
                    handle: $(this).attr('data-addon-handle') || '',
                    addonPrice: $(this).attr('data-addon-price') || '0',
                    addonCompareAtPrice: $(this).attr('data-addon-compare-at-price') || '0'
                });
            });
            $addonSelect.data('all-options', allOptions);
        }

        var allOptions = $addonSelect.data('all-options');
        var parentVal = firstDependencyValue || getVariantPickerParentValue(productId);
        var allowed = [];
        if (dependsOnList.length > 1) {
            allowed = resolveAllowedAddonHandles(config.rules, dependsOnList, valuesByDependency);
        } else if (dependsOnList.length === 1) {
            allowed = config.rules[parentVal] || [];
        }
        var allowedNormalized = $.map(allowed, function (value) {
            return $.trim((value || '').toLowerCase());
        });
        var conditionalHandles = getAllConditionalHandles(config.rules);
        var visibleOptions;
        var shouldHideAddons = $.grep(allowedNormalized, function (value) {
            return $.trim((value || '').toLowerCase()) === ADDON_RULE_HIDE_ALL;
        }).length > 0;

        if (shouldHideAddons) {
            visibleOptions = $.grep(allOptions, function (opt) {
                return !$.trim(opt.value || '');
            });
        } else if ($addonContainer.length) {
            $addonContainer.show();
        }

        if (!shouldHideAddons && dependsOnList.length) {
            visibleOptions = $.grep(allOptions, function (opt) {
                if (!opt.handle) return true;

                var handleNormalized = $.trim((opt.handle || '').toLowerCase());
                var isConditional = $.grep(conditionalHandles, function (ruleHandle) {
                    return addonHandleMatchesRule(handleNormalized, ruleHandle);
                }).length > 0;

                if (!isConditional) return true;

                return $.grep(allowedNormalized, function (allowedHandle) {
                    return addonHandleMatchesRule(handleNormalized, allowedHandle);
                }).length > 0;
            });
        } else if (!shouldHideAddons) {
            visibleOptions = filterOptionsByVariantSelection(allOptions, parentVal);
        }

        // Clear and rebuild
        $addonSelect.empty();

        $.each(visibleOptions, function (_, opt) {
            var $newOpt = $('<option>', {
                value: opt.value,
                text: opt.text
            });

            if (opt.handle) {
                $newOpt.attr('data-addon-handle', opt.handle);
            }
            $newOpt.attr('data-addon-price', opt.addonPrice || '0');
            $newOpt.attr('data-addon-compare-at-price', opt.addonCompareAtPrice || '0');

            $addonSelect.append($newOpt);
        });

        var previousValueStillVisible = previousValue && $.grep(visibleOptions, function (opt) {
            return $.trim(opt.value || '') === previousValue;
        }).length > 0;

        $addonSelect.val(previousValueStillVisible ? previousValue : '');

        if (shouldHideAddons && $addonContainer.length) {
            $addonContainer.hide();
        }

        $addonSelect.trigger('change');
    }

    function wireLineItemTextValidation() {
        $(document)
            .off('input.lineItemText', '[data-line-item-type="text"]')
            .on('input.lineItemText', '[data-line-item-type="text"]', function () {
                validateLineItemInput($(this));
            });
    }

    function validateLineItemInput($input) {
        var type = $input.attr('data-line-item-type');
        if (type !== 'text') return true;

        var value = $input.val() || '';
        var maxLength = parseInt($input.attr('data-max-length') || '15', 10);
        var regex = new RegExp($input.attr('data-regex') || '^[A-Za-z0-9]+$');
        var allowedChars = $input.attr('data-allowed-chars') || 'alphanumeric';
        var uppercaseOnly = $input.attr('data-uppercase') === 'true';
        var $error = $input.siblings('[data-line-item-error]');

        if (allowedChars === 'letters') {
            value = value.replace(/[^A-Za-z]/g, '');
        } else {
            value = value.replace(/[^A-Za-z0-9]/g, '');
        }

        if (uppercaseOnly) {
            value = value.toUpperCase();
        }

        value = value.substring(0, maxLength);
        $input.val(value);

        var isRequired = $input.prop('required');
        var isValid = true;
        var message = '';

        if(isRequired && !value && maxLength == 1) {
            isValid = false;
            message = 'This field is required. Only fill in 1 alphabet.';
        } else if (isRequired && !value) {
            isValid = false;
            message = 'This field is required.';
        } else if (value && !regex.test(value)) {
            isValid = false;
            message = allowedChars === 'letters' ? 'Only uppercase letters allowed.' : 'Only letters and numbers allowed.';
        } else if (value && value.length > maxLength) {
            isValid = false;
            message = 'Maximum ' + maxLength + ' characters.';
        }

        if ($error.length) {
            $error.text(message);
        }

        $input.toggleClass('is-invalid', !isValid);

        return isValid;
    }

    function wireDynamicLetterFields() {
        $('[data-dynamic-letter-group]').each(function () {
            var $group = $(this);
            var productId = $group.attr('data-product-id');
            var dependsOn = $group.attr('data-depends-on');
            var rules = parseLetterCountRules($group.attr('data-letter-count-rules') || '');
            var $target = $group.find('[data-dynamic-letter-fields]').first();
            var $parent = findDynamicLetterDependency(productId, dependsOn);

            if (!$target.length || !$parent.length) return;

            function apply() {
                var parentValue = getDependencyValue($parent);
                var count = rules[parentValue] || 0;
                renderDynamicLetterFields($target, productId, count);
            }

            $parent.off('change.dynamicLetters').on('change.dynamicLetters', apply);
            apply();
        });
    }

    function parseLetterCountRules(raw) {
        var map = {};
        if (!raw) return map;

        raw = raw.replace(/<br\s*\/?>/gi, '\n');

        raw.split(/[\n\r]+/).forEach(function(line) {
            line = $.trim(line);
            if (!line) return;

            var parts = line.split('=');
            if (parts.length < 2) return;

            var key = $.trim(parts[0]);
            var count = parseInt($.trim(parts.slice(1).join('=')), 10);

            if (key && !isNaN(count) && count > 0) {
                map[key] = count;
            }
        });

        return map;
    }

    function findDynamicLetterDependency(productId, dependsOn) {
        var $lineItemField = $('[data-line-item-input][data-product-id="' + productId + '"][data-property-name="' + dependsOn + '"]').first();
        if ($lineItemField.length) return $lineItemField;

        var optionName = 'options[' + dependsOn + ']';
        var $variantPicker = $('variant-picker[data-product-id="' + productId + '"]').first();
        if (!$variantPicker.length) return $();

        var $select = $variantPicker.find('select.variant-option__select[name="' + optionName + '"]').first();
        if ($select.length) return $select;

        var $checkedRadio = $variantPicker.find('input[name="' + optionName + '"]:checked').first();
        if ($checkedRadio.length) return $checkedRadio;

        return $();
    }

    function getDependencyValue($input) {
        if (!$input || !$input.length) return '';
        return $.trim($input.val() || '');
    }

    function renderDynamicLetterFields($target, productId, count) {
        var ordinals = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth', 'Ninth', 'Tenth'];
        var previousValues = {};

        $target.find('[data-line-item-input]').each(function () {
            var key = $(this).attr('data-property-name');
            if (key) previousValues[key] = $(this).val();
        });

        $target.empty();

        if (!count) {
            $target.prop('hidden', true);
            return;
        }

        for (var i = 0; i < count; i++) {
            if(count <= 1) {
                var labelText = 'Choose your Initial (A-Z)';
            } else {
                var labelText = (ordinals[i] || ('Letter ' + (i + 1))) + ' letter';
            }

            var inputId = 'dynamic-letter-' + productId + '-' + i;
            var propertyName = labelText;
            var value = previousValues[propertyName] || '';

            var $field = $('<div>', { class: 'line-item-field__dynamic-letter' });
            var $label = $('<label>', {
                class: 'line-item-field__label',
                for: inputId,
                text: labelText
            });
            var $input = $('<input>', {
                id: inputId,
                type: 'text',
                maxlength: 1,
                placeholder: 'A',
                autocomplete: 'off',
                autocapitalize: 'characters',
                autocorrect: 'off',
                spellcheck: false,
                required: true
            })
                .attr('data-line-item-input', '')
                .attr('data-product-id', productId)
                .attr('data-property-name', propertyName)
                .attr('data-line-item-type', 'text')
                .attr('data-regex', '^[A-Z]$')
                .attr('data-max-length', '1')
                .attr('data-allowed-chars', 'letters')
                .attr('data-uppercase', 'true')
                .val(value);
            var $error = $('<div>', {
                class: 'line-item-field__error',
                'data-line-item-error': ''
            });

            $field.append($label, $input, $error);
            $target.append($field);
        }

        $target.prop('hidden', false);
    }

    function wireAddonDependencies() {
        $('[data-addon-select]').each(function() {
            var $addonSelect = $(this);
            var productId = $addonSelect.attr('data-product-id');
            if (!productId) return;

            var namespace = '.addonFilter' + productId;
            var lineItemSelector = '[data-line-item-input][data-product-id="' + productId + '"]';
            var variantSelector = 'variant-picker[data-product-id="' + productId + '"] select.variant-option__select, variant-picker[data-product-id="' + productId + '"] fieldset.variant-option input';

            $(document)
                .off('change' + namespace, lineItemSelector)
                .on('change' + namespace, lineItemSelector, function() {
                    filterAddonOptions(productId);
                });

            $(document)
                .off('change' + namespace, variantSelector)
                .on('change' + namespace, variantSelector, function() {
                    filterAddonOptions(productId);
                });

            filterAddonOptions(productId);
        });
    }

    function initVariantPrefixSpacing(root) {
        var paddingSpacing = 5;
        var $root = root ? $(root) : $(document);
        var $wrappers = $root.find('.variant-option__select-wrapper--with-prefix');
        if (!$wrappers.length && $root.is('.variant-option__select-wrapper--with-prefix')) {
            $wrappers = $root;
        }

        $wrappers.each(function () {
            var $wrapper = $(this);
            var $prefix = $wrapper.find('.variant-option__select-prefix').first();
            var $select = $wrapper.find('select.variant-option__select').first();
            if (!$prefix.length) return;

            var prefixWidth = Math.ceil($prefix.outerWidth() || 0);
            var leftPadding = prefixWidth + paddingSpacing;
            $prefix.css('width', prefixWidth + 'px');
            if ($select.length) $select.css('padding-left', leftPadding + 'px');
        });
    }

    function bindVariantPrefixSpacingEvents() {
        if (variantPrefixSpacingBound) return;
        variantPrefixSpacingBound = true;

        $(document)
            .off(
                'change.variantPrefixSpacing',
                'variant-picker select.variant-option__select, variant-picker fieldset.variant-option input'
            )
            .on(
                'change.variantPrefixSpacing',
                'variant-picker select.variant-option__select, variant-picker fieldset.variant-option input',
                function () {
                    var picker = $(this).closest('variant-picker').get(0);
                    requestAnimationFrame(function () {
                        initVariantPrefixSpacing(picker || document);
                    });
                }
            );

        if (variantPrefixSpacingObserver || typeof MutationObserver === 'undefined') return;

        variantPrefixSpacingObserver = new MutationObserver(function (mutations) {
            for (var i = 0; i < mutations.length; i++) {
                var mutation = mutations[i];
                if (mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length)) {
                    requestAnimationFrame(function () {
                        initVariantPrefixSpacing(document);
                    });
                    break;
                }
            }
        });

        variantPrefixSpacingObserver.observe(document.documentElement, { childList: true, subtree: true });
    }
    
    window.addEventListener('pageshow', function () {
        initRingSizeGuideOptions();
        wireDependencies();
        wireAddonDependencies();
        wireDynamicLetterFields();
        initVariantPrefixSpacing();
        bindVariantPrefixSpacingEvents();
    });

    document.addEventListener('custom-product:reinit', function () {
        initRingSizeGuideOptions();
        wireDependencies();
        wireAddonDependencies();
        wireDynamicLetterFields();
        wireLineItemTextValidation();
        initVariantPrefixSpacing();
        bindVariantPrefixSpacingEvents();
    });
})(jQuery)
